import './CloseButton.scss';
import React from 'react';
import classNames from 'classnames';
import closeIcon from '@icons/close-black.svg';

type CloseButtonProps = {
    onClick: () => void,
    large?: boolean,
    white?: boolean,
    className?: string,
    isDisabled?: boolean,
}

const CloseButton = ({
    onClick,
    large,
    white,
    className,
    isDisabled,
}: CloseButtonProps) => {
    const classes = {
        'b-close-button': true,
        large,
        white,
    };

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    };

    const btnClass = classNames(classes, className);
    return (
        <button
            className={btnClass}
            onClick={handleClick}
            disabled={isDisabled}
            data-testid='close-button'
        >
            <img className="cross-icon" src={closeIcon} />
        </button>
    );
};

export default CloseButton;
